module.exports = __webpack_public_path__ + "img/successfailure-success.fb1c7321.svg";